import React, { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import { Loading, DashboardTabs } from 'components';
import { ILoggedUserData } from 'types';
import { getLoggedUserData } from 'utils';
import { BASE_TABS_CONFIG } from './tabs-config';

export const SitesPageV2 = () => {
  const loggedUserData: ILoggedUserData = getLoggedUserData();
  const isAdminUser = loggedUserData.roles?.some(
    (rol: string) => rol === 'MODULE_ADMIN' || rol === 'SUPER_ADMIN'
  );

  const TABS_CONFIG = BASE_TABS_CONFIG.filter((tab) => !tab.adminOnly || isAdminUser);

  const [selectedTab, setSelectedTab] = useState<string>(() => {
    const savedTab = sessionStorage.getItem('siteTab');
    const parsedTab = savedTab ? JSON.parse(savedTab) : null;
    const defaultTab = TABS_CONFIG[0]?.value || BASE_TABS_CONFIG[0].value;
    return typeof parsedTab === 'number' && parsedTab < TABS_CONFIG.length
      ? TABS_CONFIG[parsedTab].value
      : defaultTab;
  });
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  const handleTabChange = (tabIndex: number) => {
    if (tabIndex >= 0 && tabIndex < TABS_CONFIG.length) {
      const newValue = TABS_CONFIG[tabIndex].value;
      setSelectedTab(newValue);
      sessionStorage.setItem('siteTab', JSON.stringify(tabIndex));
    }
  };

  if (isLoading) return <Loading />;

  return (
    <Box sx={{ ml: 3 }}>
      <DashboardTabs
        intensity
        tabs={TABS_CONFIG}
        selectedBtnOption={selectedTab}
        onTabChange={handleTabChange}
      />
    </Box>
  );
};